import React, { useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import PropTypes from 'prop-types';
import { identityRegion, dashboardRegion } from '../../constants/Constants';
import { getIdToken, getAccessToken } from '../../utility/common';
import { userGuide } from '../../actions/userguide/UserGuide';
import UserGuide from '../../components/userguide/UserGuide';

const UserGuideContainer = (props) => {
  const userGuideData = useSelector((state) => state.getUserGuide);
  const dashboardParams = {
    identityRegion,
    dashboardRegion,
    openIdToken: getIdToken(),
    accessToken: getAccessToken(),
  };
  let urlsData = [];
  const {
    isUgSending, ugError, ugData,
  } = userGuideData;
  if (ugData) {
    // eslint-disable-next-line new-cap
    const jsonData = new Buffer.from(ugData, 'base64');
    urlsData = JSON.parse(jsonData.toString()).data;
  }
  useEffect(() => {
    props.userGuide(dashboardParams);
  }, []);

  return (
    <div>
      <UserGuide
        urlsData={urlsData}
        ugError={ugError}
        isUgSending={isUgSending}
      />
    </div>
  );
};

/** Required function and props with the proptypes */
UserGuideContainer.propTypes = {
  userGuide: PropTypes.func.isRequired,
};

const mapDispatchedToProps = {
  userGuide,
};

export default connect(null, mapDispatchedToProps)(UserGuideContainer);
